// @flow

import _ from 'lodash/fp';
import {
  DATA_REQUEST,
  DATA_SUCCESS,
  DATA_FAILURE,
  FILTER,
} from '../actions/siteManagerReportView';

import type {
  Apartment,
  Project,
} from '../actions/purchaseReportView';
import type {SiteManagerReportAction} from '../actions/siteManagerReportView';
import type {ErrorDto} from '../dtos';
import type {Exact} from './configTemplateView';

export type SiteManagerReportState = {
  apartmentIds: number[],
  apartments: Apartment[],
  error: ?ErrorDto,
  isFetching: boolean,
  projectId: ?number,
  projects: Project[],
  includePlans: boolean
}

const defaultState: SiteManagerReportState = {
  apartmentIds: [],
  apartments: [],
  error: null,
  isFetching: false,
  projectId: null,
  projects: [],
  includePlans: false,
};

const siteManagerReportView = (state: SiteManagerReportState = defaultState, action: SiteManagerReportAction): Exact<SiteManagerReportState> => {
  switch (action.type) {
    case DATA_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        apartmentIds: [],
        apartments: [],
        projectId: null,
        projects: _.sortBy([x => x.name], action.projects),
        includePlans: false,
      };
    case DATA_FAILURE:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };
    case FILTER:
      const newProject = state.projectId !== action.projectId;
      let apartments = state.apartments;
      if (!!newProject) {
        const project = _.find({id: action.projectId}, state.projects);
        apartments = !!project
          ? project.apartments
          : [];
      }
      return {
        ...state,
        apartmentIds: newProject ? [] : action.apartmentIds,
        apartments: _.sortBy([x => x.objectId], apartments),
        projectId: action.projectId,
        includePlans: !!action.includePlans,
      };
    default:
      return state;
  }
};

export default siteManagerReportView;



// WEBPACK FOOTER //
// ./src/reducers/siteManagerReportView.js